import { render, staticRenderFns } from "./motherboard.vue?vue&type=template&id=617b7652&"
import script from "./motherboard.vue?vue&type=script&lang=js&"
export * from "./motherboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports